const Playlists = {
    allOut1960s: '37i9dQZF1DXaKIA8E7WcJj',
    allOut1970s: '37i9dQZF1DWTJ7xPn4vNaz',
    allOut1980s: '37i9dQZF1DX4UtSsGT1Sbe',
    allOut1990s: '37i9dQZF1DXbTxeAdrVG2l',
    allOut2000s: '37i9dQZF1DX4o1oenSJRJd',
    allOut2010s: '37i9dQZF1DX5Ejj0EkURtP'
}

export default Playlists;
